import type { ChartOptions } from "chart.js";

export const cubeHomeChartInteractionEvents = ["mousemove", "mouseout", "click", "touchstart", "touchmove"] as const;

export const withCubeHomeChartScrollPassthrough = <T extends "bar" | "line">(
  options: ChartOptions<T>,
): ChartOptions<T> => ({
  ...options,
  events: [...cubeHomeChartInteractionEvents],
});
